import React from 'react';
import { FieldLabel, Paragraph } from 'common-components/typography';
import { Row } from 'antd';
import { PrimaryButton } from 'common-components/buttons';
import _ from 'lodash';
import moment from 'moment-timezone';
import { Text } from '@good/ui/core';
import { Worker } from './types';

interface AssignWorkerStep15Props {
  displayTimezone: string | undefined;
  onClose: () => void;
  scheduledRemoveConflict: unknown | null;
  selectedWorker: Worker | null;
}

export const AssignWorkerStep15 = ({
  displayTimezone,
  onClose,
  scheduledRemoveConflict,
  selectedWorker,
}: AssignWorkerStep15Props) => {
  const removalDate = scheduledRemoveConflict ? scheduledRemoveConflict.removedOn : '';
  const name = selectedWorker ? `${selectedWorker.firstName} ${selectedWorker.lastName}` : '';
  const bookings = scheduledRemoveConflict.sessions || scheduledRemoveConflict.shiftSlots || [];

  return (
    <>
      <Paragraph>
        The selected team member, <Text weight='bold'>{name}</Text>, is scheduled to be remove on or before the
        scheduled booking time
      </Paragraph>
      <Paragraph className='mt-small'>As a result {name} will not be assigned to this booking</Paragraph>
      <div className='mb-x2-small'>
        <FieldLabel text={'TEAM MEMBER SCHEDULE TO BE REMOVE ON...'} />
      </div>
      <Paragraph>{moment.tz(removalDate, displayTimezone).format('DD MMMM YYYY')}</Paragraph>

      <div className='mb-x2-small'>
        <FieldLabel text={'BOOKING DATE'} />
      </div>
      <div className='flex-column'>
        <Text>{moment.tz(bookings[0].startDateTime, displayTimezone).format('DD MMMM YYYY')}</Text>
        <Text>
          {moment.tz(bookings[0].startDateTime, displayTimezone).format('HH:mm A')} -{' '}
          {moment.tz(bookings[1].endDateTime, displayTimezone).format('HH:mm A')}
        </Text>
      </div>
      <div className='mt-x3-large'>
        <Row type={'flex'} justify={'end'}>
          <PrimaryButton size='large' onClick={onClose}>
            Confirm
          </PrimaryButton>
        </Row>
      </div>
    </>
  );
};
